import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Menopause Consent Form',
    educationalSlide: `
    <p><b>1. Consent to Nursing / Support Services</b><br />- I consent to receive education, support, and guidance related to my health concerns.<br />- Services may include consultation, follow-up, and care coordination.<br />- Services may result in recommendations for further assessment, referral to other providers, or additional testing at my own responsibility and cost.</p>
    <p><b>2. Scope of Services</b><br />- Menopause services are supportive and educational in nature.<br />- RN services are provided within nursing scope, including education, symptom support, and care coordination.<br />- NP services are responsible for diagnosis, treatment decisions, and prescribing where clinically appropriate.</p>
    <p><b>3. Client Responsibility Acknowledgement</b><br />- I am responsible for seeking appropriate medical care when needed.<br />- I am responsible for following up with my primary care provider.<br />- These services do not replace emergency or urgent care.</p>
    <p><b>4. Limitations of Services</b><br />- No guarantee of outcomes is provided.<br />- The provider cannot predict progression of symptoms or individual response to interventions.<br />- Services may not eliminate the need for in-person care or specialist referral.</p>
    <p><b>5. Virtual Care Consent</b><br />- I agree to participate in virtual services.<br />- I agree to electronic communication of health information as needed for care.<br />- I acknowledge limitations of virtual care, including technology and remote assessment limitations.<br />- I may withdraw consent to virtual care at any time.</p>
    <p><b>6. Privacy & Confidentiality (Ontario PHIPA)</b><br />- PHI is collected, used, and disclosed in compliance with PHIPA (Ontario) and other applicable laws.<br />- PHI may be used for care delivery, communication with providers, billing, and quality improvement.<br />- Client rights include requesting access to records, requesting corrections, and withdrawing consent for certain uses or disclosures, subject to legal and clinical limits.</p>
    <p><b>7. Information Sharing</b><br />- I consent to sharing relevant health information with my care team members, including NP, RN, dietitian, and other involved providers.<br />- I consent to sharing information with other providers as needed for my care.<br />- Information sharing is limited to what is reasonably necessary for care.</p>
    <p><b>8. Informed Consent Confirmation</b><br />- I confirm I have received and understood information about these services.<br />- I confirm I have had the opportunity to ask questions.<br />- I voluntarily consent to proceed.</p>
    `,
    field: 'menopause_consent_form',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Print Name',
          type: 'text',
          placeholder: 'Please enter your name',
          name: 'name',
          halfWidth: true
        },
        {
          label: 'Signing Date',
          type: 'date',
          required: true,
          name: 'date',
          halfWidth: true
        },
        {
          label: 'Signature',
          type: 'esign',
          required: true,
          name: 'signature'
        }
      ]
    }
  }
];

export default questionsModels;
